module.exports = __webpack_public_path__ + "static/media/RightArrow.a92d7ba4.svg";